import useLogged from 'hooks/useLogged';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PropTypes } from 'prop-types';

function RequireAuth({ children }) {
  const isLogged = useLogged();
  let location = useLocation();

  if (isLogged !== null && !isLogged) {
    return (
      <Navigate
        to={`/login?redirectUrl=${window.location.href}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.element
};

export default RequireAuth;
